import { render, staticRenderFns } from "./Assinante.vue?vue&type=template&id=f89c9f12&scoped=true"
import script from "./Assinante.vue?vue&type=script&lang=js"
export * from "./Assinante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89c9f12",
  null
  
)

export default component.exports